const number = val => {
    val = val?.replace(/[\D]/g, '');
    return val
}

export const Parsers = {
    number
}